import { useBannerContext } from '../../../context/PlpContext';

export const useBannerData = () => {
  const bannerContext = useBannerContext();

  return {
    bannerContext,
  };
};
